import { StorageService } from "src/modules/base/shared/services/storage.service";

export default class menuParseDecorator  {
    parseMenu(response,appService){
        try{
            var menuList = response.menus;
            var userRoles = response.user_roles;
            var obj = localStorage.getItem("MAIN_ACCOUNT");
            if(obj != null){
                if(userRoles && userRoles.length && userRoles[0].role != undefined && userRoles[0].role == 'Citizen'){
                    for(let m in menuList){
                        var mnu = menuList[m]; 
                        if(mnu.name == "Search Speciality"){
                            menuList.splice(m, 1);
                            break;
                        }
                    }
                    return menuList;
                
                }
                //TODO for other roles
            }
            
            console.log("appService",appService)     
        }catch(e){
            console.warn(e);
            return menuList;
        }
       
        
        return menuList;
    }
}

